// extracted by mini-css-extract-plugin
module.exports = {"single-auto-complete":"single-auto-complete--11P9wyBgso","singleAutoComplete":"single-auto-complete--11P9wyBgso"};